var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandDomain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18.01",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26430",
    "data-name": "Group 26430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_partners24x24",
    "data-name": "btn partners24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46246",
    "data-name": "Path 46246",
    d: "M877.71,463.76a4.66,4.66,0,0,1-.86-2.08h-4.38a9,9,0,0,0,2.15,5.17Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46247",
    "data-name": "Path 46247",
    d: "M876.85,460.31a4.71,4.71,0,0,1,.86-2.08l-3.1-3.09a9,9,0,0,0-2.14,5.17Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46248",
    "data-name": "Path 46248",
    d: "M878.7,457.24a4.84,4.84,0,0,1,2.08-.87V452a9,9,0,0,0-5.17,2.15Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46249",
    "data-name": "Path 46249",
    d: "M882.16,452v4.37a4.76,4.76,0,0,1,2.07.87l3.1-3.1A9.1,9.1,0,0,0,882.16,452Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46250",
    "data-name": "Path 46250",
    d: "M885.23,458.23a4.83,4.83,0,0,1,.86,2.08h4.38a9.06,9.06,0,0,0-2.15-5.17Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46251",
    "data-name": "Path 46251",
    d: "M880.78,465.62a4.73,4.73,0,0,1-2.08-.87l-3.09,3.1a9.11,9.11,0,0,0,5.17,2.15Z",
    transform: "translate(-872.47 -452)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_url_1014254",
    "data-name": "noun url 1014254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26428",
    "data-name": "Group 26428",
    fill: "#999",
    stroke: "#999",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46838",
    "data-name": "Path 46838",
    d: "M885.39,464.81a3.32,3.32,0,0,0,.69-1.08.48.48,0,0,0-.27-.62h0a.47.47,0,0,0-.37,0,.44.44,0,0,0-.25.27,2,2,0,0,1-3.25.74l-1.75-1.74a2,2,0,0,1,1.38-3.35,2,2,0,0,1,1.4.58l1.62,1.62a.48.48,0,0,0,.82-.36.41.41,0,0,0-.14-.31l-1.61-1.64a2.9,2.9,0,0,0-2.08-.86h0a2.94,2.94,0,0,0-2.07,5l1.73,1.72a2.94,2.94,0,0,0,2.08.86A3,3,0,0,0,885.39,464.81Z",
    transform: "translate(-872.47 -452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46839",
    "data-name": "Path 46839",
    d: "M889,464.28l-1.75-1.72a2.95,2.95,0,0,0-4.16,0,3.32,3.32,0,0,0-.69,1.08.55.55,0,0,0,0,.38.57.57,0,0,0,.28.25.48.48,0,0,0,.62-.28h0a2.1,2.1,0,0,1,.46-.74,2,2,0,0,1,1.39-.57,2,2,0,0,1,1.39.57l1.73,1.73a2,2,0,0,1,0,2.78,1.87,1.87,0,0,1-1.36.58h0a1.94,1.94,0,0,1-1.37-.57l-1.65-1.62a.46.46,0,0,0-.36-.14.43.43,0,0,0-.32.14.45.45,0,0,0-.14.36.43.43,0,0,0,.14.32l1.62,1.62a2.86,2.86,0,0,0,2.08.86,2.94,2.94,0,0,0,2.94-2.94A3.05,3.05,0,0,0,889,464.28Z",
    transform: "translate(-872.47 -452)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandDomain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brandDomain.7f5ec919eb864686a0d96c40917500bd.svg";